import PropTypes from 'prop-types';

export interface BuildAssetsOptions {
    isBrandSpecialistVideosEnabled: boolean;
}

export enum AssetType {
    BRAND_SPECIALIST_VIDEO = 'BRAND_SPECIALIST_VIDEO',
    IMAGE = 'IMAGE',
    YOUTUBE = 'YOUTUBE_VIDEO',
}

export interface AssetInfo {
    id: string;
    previewUrl: string;
    title: string;
    alt: string;
    assetType: AssetType;
    assetUrl: string;
}

export const AssetInfoPropTypes = PropTypes.exact({
    id: PropTypes.string.isRequired,
    previewUrl: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    assetType: PropTypes.oneOf(Object.values(AssetType)).isRequired,
    assetUrl: PropTypes.string.isRequired,
    zoomUrl: PropTypes.string,
});
